<template>
  <template v-if="toolboxGroup">
    <IconChartPie size="24" style="padding:10px;" />
    <p>Chart</p>
  </template>

  <template v-else>
    <div class="editable-element-chart"
         :class="{ 'lock': false }"
         :style="{
      maxWidth: '100%',
      width: '100%'
    }"
    >
      <div
          class="rotate-wrapper"
          :style="{ transform: `rotate(${elementData.rotate}deg)` }"
      >
        <div
            class="element-content"
            :style="{
          backgroundColor: elementData.fill,
          width: px(elementData.style?.containerWidth, 'auto'),
          height: px(elementData.style?.containerHeight, 'auto'),
          maxWidth: `calc(100vw - ${extraWidth})`,
          maxHeight: '100vh',
          overflow: 'hidden'
        }"
        >
          <ElementOutline
              :width="elementData.width"
              :height="elementData.height"
              :outline="elementData.outline"
          />
          <HighchartsChart
              :data="elementData.data"
              :themeColor="elementData.themeColor"
              :type="elementData.chartType"
              :title="elementData.chartTitle ?? ''"
              :options="elementData.options"
              :jspreadsheet="elementData.jspreadsheet ?? null"
              :compact="elementData.compact"
              :width="elementData.style?.containerWidth"
              :height="elementData.style?.containerHeight"
          />
        </div>
      </div>
    </div>
  </template>
</template>

<script lang="ts" setup>
import {computed, getCurrentInstance, onMounted, ref} from 'vue'

import ElementOutline from '@/views/components/element/ElementOutline.vue'
import HighchartsChart from "@/views/components/element/ChartElement/HighchartsChart.vue";

const props = defineProps({
  elementData: {
    type: Object
  }
})

const extraWidth = computed(() => {
  return px(getAttrNumber(props.elementData, 'margin', 'marginRight') +
      getAttrNumber(props.elementData, 'margin', 'marginLeft') +
      getAttrNumber(props.elementData, 'padding', 'paddingRight') +
      getAttrNumber(props.elementData, 'padding', 'paddingLeft'), '0')
})


const getAttrNumber = (element, all, which) => {
  if (!element?.style || (!element?.style[all] && !element?.style[which])) {
    return 0
  }
  return element?.style[all] ? element?.style[all] : element?.style[which]
}

const toolboxGroup = computed(() => {
  const parentClassList = getCurrentInstance().parent.attrs.class;
  return parentClassList === "dragArea toolbox-group"
});

const px = (input, defaultValue) => {
  if (input) {
    return `${input}px`
  }
  else {
    return defaultValue
  }
}

const windowWidth = ref(px(window.innerWidth))





const updateWindowWidth = () => windowWidth.value = px(window.innerWidth)

onMounted(() => {
  window.addEventListener("resize", updateWindowWidth)
})

</script>

<style lang="scss" scoped>
.editable-element-chart {

  &.lock .element-content {
    cursor: default;
  }
}
.rotate-wrapper {
  width: 100%;
  height: 100%;
}
.element-content {
  width: 100%;
  height: 100%;
  cursor: move;

}

@media (max-width: 768px) {
  .element-content {
    width: v-bind(windowWidth) !important;
    height: auto !important;
  }
}
</style>
